import { motion } from 'framer-motion';
import styled from 'styled-components';

export const PageWrapper = styled(motion.div)`
	/* margin-top: 60px; */
`;
